import { render, staticRenderFns } from "./Cardqueue.vue?vue&type=template&id=04abf1fc&scoped=true"
import script from "./Cardqueue.vue?vue&type=script&lang=js"
export * from "./Cardqueue.vue?vue&type=script&lang=js"
import style0 from "./Cardqueue.vue?vue&type=style&index=0&id=04abf1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abf1fc",
  null
  
)

export default component.exports